import React from 'react'; // CARS
// import MyCars from '../ExClass/ExClass'

const Car = ({children, color}) => { 

    const colorInfo = color ? (<p>Couleur: { color } </p>) : (<p>Couleur: pas de couleur </p>);


    return (
        <div className="bg-info w-25 text-center mx-auto p-1 m-1 rounded-lg">
            <p>Marque: { children } </p> 
            {colorInfo}
        </div>
    )
}

export default Car;